import { AbstractControl, FormControl } from '@angular/forms'

export class ValuesMatchValidator {
  constructor(private slave: AbstractControl) {
    this.validate = this.validate.bind(this)
  }

  validate(control: FormControl): Object {
    if(!control.value || !this.slave || !this.slave.touched) { return null }
    if(control.value == this.slave.value) {
      return null
    } else {
      return { valuesmatch: { master: control.value, slave: this.slave.value } }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators/values-match.validator.ts